import React from 'react';
import { Button, Text } from "../../Atoms";
import { COLOR_BUTTON } from "../../Config/Config";
import { IconTitleMolecule } from '../../Molecules';
import { Link } from 'react-router-dom';
 
const TemplateConfirmationPrelevement = () => {
  return (
    <div className="template-scroll template-container cotisations mt-20 d-flex flex-column">
      <div className="content-large-max">
        <IconTitleMolecule
          text="Votre demande de prélèvement est prise en compte!"
          className="title-page font-title mt-40"
          icon="alert-info"
          size='icon-x2'
        />  
        <Text
          text="Notre équipe de gestion vous contactera pour la mise en place du prélèvement automatique."
          type="h8"
          className="mt-20"
        />
        <Text
          text="Merci de votre confiance et à bientôt sur CGRM!"
          type="h8"
          className="mt-20"
        />
 
        <div className="mt-40 text-center">
          <div className="text-center">
            <Link to="/" >
              <Button
                text="Retour à l'accueil de CGRM"
                className="button-red-rounded"
                color={COLOR_BUTTON.SECOND_RED}
              />
            </Link>
          </div>
        </div>
      </div>      
    </div>
  );
}

export default TemplateConfirmationPrelevement;
